import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { addMatrix } from "actions/matrix";
import { ASSESSMENT_MATRIX } from "constants/matrixTypes";
import { allEntriesEqual } from "helpers/array";
import { newGuid } from "helpers/guid";
import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Checkbox } from '@haldor/ui';
import MatrixParagraph from "./MatrixParagraph";
import { FlexibleTextArea } from "UI/Inputs";
import swal from "sweetalert2";
/* Component for creating Matrixes **/

var MatrixForm = /*#__PURE__*/function (_Component) {
  _inherits(MatrixForm, _Component);

  var _super = _createSuper(MatrixForm);

  function MatrixForm(props) {
    var _this;

    _classCallCheck(this, MatrixForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onLevelChange", function (event) {
      var stepSize = parseInt(event.target.value, 10);
      var _ParagraphSet = _this.state._ParagraphSet;

      if (stepSize > 0) {
        if (stepSize > _this.state.stepSize) {
          _ParagraphSet.map(function (paragraph, i) {
            var rows = paragraph.rows;
            rows.map(function (row, i) {
              var neededSteps = parseInt(stepSize, 10) - (row.cells.length - 1);

              for (var _i = 0; neededSteps > _i; _i++) {
                row.cells.push({
                  id: newGuid(),
                  keyId: newGuid(),
                  text: ""
                });
              }

              return row;
            });
            paragraph.rows = rows;
            return paragraph;
          });

          _this.setState({
            stepSize: stepSize,
            _ParagraphSet: _ParagraphSet
          }, function () {
            _this.props.onMatrixFormUpdate(_this.state);
          });
        } else {
          var filledCell = null;

          _ParagraphSet.map(function (paragraph, i) {
            var rows = paragraph.rows;
            rows.map(function (block, i) {
              if (block.cells != null && block.cells.length > stepSize && filledCell == null) {
                var desiredSteps = stepSize;

                if (block.cells[0].gradeF) {
                  desiredSteps++;
                }

                for (i = desiredSteps; i < block.cells.length; i++) {
                  if (block.cells[i].text != "") {
                    filledCell = true;
                  }
                }
              }
            });
          }); // Cells has been edited, show prompt


          if (filledCell != null) {
            swal.fire({
              title: _this.props.translate("warning"),
              text: _this.props.translate("your-step-will-be-overwritten"),
              showCancelButton: true,
              cancelButtonText: _this.props.translate("abort"),
              confirmButtonText: _this.props.translate("proceed"),
              focusConfirm: false
            }).then(function (result) {
              if (result.value != null) {
                _ParagraphSet.map(function (paragraph, i) {
                  var rows = paragraph.rows;
                  rows.map(function (block, i) {
                    if (block.cells != null && block.cells.length > stepSize) {
                      var desiredSteps = stepSize;

                      if (block.cells[0].gradeF) {
                        desiredSteps++;
                      }

                      if (block.cells.length < desiredSteps) {
                        block.cellscells.push({
                          id: newGuid(),
                          keyId: newGuid(),
                          text: ""
                        });
                      }

                      block.cells.length = desiredSteps;
                    }
                  });
                });

                _this.setState({
                  stepSize: stepSize,
                  _ParagraphSet: _ParagraphSet
                }, function () {
                  _this.props.onMatrixFormUpdate(_this.state);
                });
              }
            });
          } else {
            _ParagraphSet.map(function (paragraph, i) {
              var rows = paragraph.rows;
              rows.map(function (block, i) {
                if (block.cells != null && block.cells.length > stepSize) {
                  var desiredSteps = stepSize;

                  if (block.cells[0].gradeF) {
                    desiredSteps++;
                  }

                  if (block.cells.length < desiredSteps) {
                    block.cellscells.push({
                      id: newGuid(),
                      keyId: newGuid(),
                      text: ""
                    });
                  }

                  block.cells.length = desiredSteps;
                }
              });
            });

            _this.setState({
              stepSize: stepSize,
              _ParagraphSet: _ParagraphSet
            }, function () {
              _this.props.onMatrixFormUpdate(_this.state);
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMatrixTitleChange", function (text) {
      var title = text;

      _this.setState({
        title: title
      }, function () {
        _this.props.onMatrixFormUpdate(_this.state);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDisableNotAchieved", function (checked) {
      var disableNotAchieved = _this.state.disableNotAchieved;
      disableNotAchieved = !checked;
      var _ParagraphSet = _this.state._ParagraphSet;

      _ParagraphSet.map(function (paragraph, i) {
        var rows = paragraph.rows;

        if (!checked) {
          if (rows.length > 0) {
            rows.map(function (row) {
              var fIndex = row.cells.findIndex(function (cell) {
                return cell.gradeF == true;
              });

              if (fIndex > -1) {
                row.cells.splice(fIndex, 1);
              }

              return row;
            });
          }
        } else {
          if (rows.length > 0) {
            var gradeF = {
              id: newGuid(),
              text: _this.props.translate("not-achieved"),
              gradeF: true
            };
            rows.map(function (row) {
              row.cells.unshift(gradeF);
              return row;
            });
          }
        }

        _ParagraphSet[i].rows = rows;
      });

      _this.setState({
        disableNotAchieved: disableNotAchieved,
        _ParagraphSet: _ParagraphSet
      }, function () {
        _this.props.onMatrixFormUpdate(_this.state);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphAdd", function (event) {
      event.preventDefault();
      var _ParagraphSet = _this.state._ParagraphSet;
      var paragraphNr = _ParagraphSet.length;
      var row = {
        id: newGuid(),
        sentenceNr: 1,
        cells: []
      };

      if (!_this.state.disableNotAchieved) {
        row.cells.push({
          id: newGuid(),
          text: _this.props.translate("not-achieved"),
          gradeF: true
        });
      }

      if (_this.state.stepSize > 0) {
        for (var i = 0; _this.state.stepSize > i; i++) {
          row.cells.push({
            id: newGuid(),
            keyId: newGuid(),
            text: ""
          });
        }
      }

      paragraphNr++;

      _ParagraphSet.push({
        id: newGuid(),
        title: "",
        subtitle: "",
        paragraphNr: paragraphNr,
        rows: [row]
      });

      _this.setState({
        _ParagraphSet: _ParagraphSet
      }, function () {
        _this.props.onMatrixFormUpdate(_this.state);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphUpdate", function (Paragraph) {
      var _ParagraphSet = _this.state._ParagraphSet;

      var paragraph = _ParagraphSet.find(function (p) {
        return p.id == Paragraph.id;
      });

      paragraph.title = Paragraph.title;
      paragraph.subtitle = Paragraph.subtitle;
      paragraph.rows = Paragraph.rows;
      paragraph.paragraphNr = Paragraph.paragraphNr;

      _this.setState({
        paragraph: paragraph
      }, function () {
        _this.props.onMatrixFormUpdate(_this.state);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphDelete", function (Paragraph) {
      var _ParagraphSet = _this.state._ParagraphSet;
      _ParagraphSet = _ParagraphSet.filter(function (p) {
        return p.id != Paragraph.id;
      });
      var paragraphIndex = 0;

      _ParagraphSet.forEach(function (paragraph) {
        paragraphIndex = paragraphIndex + 1;
        paragraph.paragraphNr = paragraphIndex;
        return paragraph;
      });

      _this.setState({
        _ParagraphSet: _ParagraphSet
      }, function () {
        _this.props.onMatrixFormUpdate(_this.state);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onParagraphBlockAdd", function (Paragraph) {
      var _ParagraphSet = _this.state._ParagraphSet;

      var paragraph = _ParagraphSet.find(function (p) {
        return p.id == Paragraph.id;
      });

      paragraph.title = Paragraph.title;
      paragraph.subtitle = Paragraph.subtitle;
      paragraph.paragraphNr = Paragraph.paragraphNr;
      var rows = paragraph.rows;
      var cells = [];
      var id = newGuid();

      if (!_this.state.disableNotAchieved) {
        cells.push({
          id: newGuid(),
          text: _this.props.translate("not-achieved"),
          gradeF: true
        });
      }

      for (var i = 0; _this.state.stepSize > i; i++) {
        // Add empty step to the cells array
        cells.push({
          id: newGuid(),
          keyId: newGuid(),
          text: ""
        });
      }

      var sentenceNr = 0;

      if (rows.length > 0) {
        sentenceNr = Math.max.apply(Math, rows.map(function (o) {
          return parseInt(o.sentenceNr, 10);
        }));
      }

      sentenceNr++;
      rows.push({
        id: id,
        text: "",
        cells: cells,
        sentenceNr: sentenceNr
      });
      paragraph.rows = rows;

      _this.setState({
        paragraph: paragraph
      }, function () {
        _this.props.onMatrixFormUpdate(_this.state);
      });
    });

    if (props.matrix == null) {
      _this.state = {
        id: newGuid(),
        title: "",
        type: props.type,
        disableNotAchieved: false,
        stepSize: 0
      };
    } else {
      _this.state = {
        id: props.matrix.id,
        title: props.matrix.title,
        type: props.type,
        disableNotAchieved: props.matrix.disableNotAchieved,
        _ParagraphSet: props.matrix._ParagraphSet,
        stepSize: 0
      };
    }

    if (_this.state._ParagraphSet == null) {
      _this.state._ParagraphSet = [{
        id: newGuid(),
        title: "",
        subtitle: "",
        paragraphNr: 1,
        rows: []
      }];
    }

    _this.editing = props.editView;
    _this.disableNotAchievedToggle = false;
    return _this;
  }

  _createClass(MatrixForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "form matrix-container",
        style: {
          marginBottom: "1.25em"
        }
      }, !this.editing || this.disableNotAchievedToggle ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: "relative",
          marginTop: "2em"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          "float": "left",
          padding: 0,
          paddingRight: "1em",
          width: "200px"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        value: this.state.stepSize,
        onChange: this.onLevelChange
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, this.props.translate("choose-steps")), /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, "1 ", this.props.translate("step")), /*#__PURE__*/React.createElement("option", {
        value: "2"
      }, "2 ", this.props.translate("step")), /*#__PURE__*/React.createElement("option", {
        value: "3"
      }, "3 ", this.props.translate("step")), /*#__PURE__*/React.createElement("option", {
        value: "4"
      }, "4 ", this.props.translate("step"))))), !this.disableNotAchievedToggle ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: this.toggleDisableNotAchieved,
        value: !this.state.disableNotAchieved,
        label: this.props.translate("not-achieved")
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          "float": "left",
          padding: 0
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate("title")), /*#__PURE__*/React.createElement(FlexibleTextArea, {
        value: this.state.title != null ? this.state.title : "",
        placeholder: this.props.translate("title"),
        onChange: function onChange(event) {
          return _this2.onMatrixTitleChange(event.target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), this.state._ParagraphSet.map(function (paragraph, i) {
        return /*#__PURE__*/React.createElement(MatrixParagraph, {
          key: paragraph.id,
          paragraph: paragraph,
          disableNotAchieved: _this2.state.disableNotAchieved,
          onParagraphUpdate: _this2.onParagraphUpdate.bind(_this2),
          onParagraphDelete: _this2.onParagraphDelete.bind(_this2),
          onParagraphBlockAdd: _this2.onParagraphBlockAdd.bind(_this2)
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "2rem"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "courses-add-btn",
        onClick: this.onParagraphAdd
      }, "+ ", this.props.translate("add-core-section"))));
    }
  }]);

  return MatrixForm;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  addMatrix: addMatrix
})(MatrixForm);